import { render } from "./WorkloadRemarkDialog.vue?vue&type=template&id=16d86ed5"
import script from "./WorkloadRemarkDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadRemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__